import { isSSR, useState } from '@common'

import type { ScreenshotsProps } from './types'

export const useDebugScreenshots = (props: ScreenshotsProps): ScreenshotsProps | false => {
    const [impl, setImpl] = useState<{fn: typeof useDebugScreenshots} | null>(null)

    if (isSSR || window.location.hostname !== 'mcspot.com') return false

    if (!impl) {
        import('./debug').then(({ useDebugScreenshots }) => {
            setImpl({ fn: useDebugScreenshots })
        })
        return false
    }

    return impl.fn(props)
}
